import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-923c0020"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "the-site-description has-background-contents shadow" }
const _hoisted_2 = { class: "title" }
const _hoisted_3 = { class: "the-site-description-header" }
const _hoisted_4 = { class: "the-site-description-body" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_6 = { class: "the-site-description-license level-center is-mobile" }
const _hoisted_7 = ["alt"]
const _hoisted_8 = {
  href: "http://www.riaj.or.jp/lmark/",
  target: "_blank",
  rel: "noopener"
}
const _hoisted_9 = ["alt"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TheListAbout = _resolveComponent("TheListAbout")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("h1", _hoisted_2, _toDisplayString(_ctx.$t('rekionSiteDescription.title')), 1),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("p", null, _toDisplayString(_ctx.$t('rekionSiteDescription.description')), 1)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_TheListAbout, { class: "the-site-description-list" })
    ]),
    _hoisted_5,
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", null, _toDisplayString(_ctx.$t('rekionSiteDescription.link5')), 1),
      _createElementVNode("div", null, [
        _createElementVNode("img", {
          src: "/img/banner/jasrac.jpg",
          alt: _ctx.$t('label.jasracRegistration')
        }, null, 8, _hoisted_7)
      ]),
      _createElementVNode("div", null, [
        _createElementVNode("a", _hoisted_8, [
          _createElementVNode("img", {
            src: "/img/banner/lmark_rekion.bmp",
            alt: _ctx.$t('label.lmark')
          }, null, 8, _hoisted_9)
        ])
      ])
    ])
  ]))
}